import React from 'react';
import './RewardCongratulations.css';

interface RewardCongratulationsProps {
  message: string | JSX.Element;
  annotation?: string | JSX.Element;
}

const RewardCongratulations: React.FC<RewardCongratulationsProps> = ({ message, annotation }) => {
  return (
    <div className="reward-congratulations">
      <div className="reward-congratulations__content">
        <div className="reward-congratulations__icon">🎉</div>
        <h1 className="reward-congratulations__title">Поздравляем!</h1>
        <div className="reward-congratulations__message">
          {message}
        </div>
        <div className="reward-congratulations__instruction">
          {annotation === undefined ? 'Жми кнопку «Получить приз» и криптовалюта будет зачислена на твой ТГ-кошелек.' : annotation}          
        </div>        
      </div>
    </div>
  );
};

export default RewardCongratulations;
